import {Component, Inject, OnInit} from 'ng-metadata/core';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {LoginService} from "../login/login.service";
import {MediaQueries} from "../../infra/mediaQueries.service";

@Component({
    selector: 'prm-timeout-toast',
    templateUrl: 'components/security/timeoutToast/timeout-toast.html',
})

export class PrmTimeoutToast implements OnInit{
    constructor(private primolyticsService: PrimolyticsService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private loginService: LoginService,
                private mediaQueries: MediaQueries) {
    }

    ngOnInit() {
    }

    private onDismiss() {
        this.$mdToast.hide();

    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }

    @beacon({'p':'general', 'op':'signIn'})
    handleLogin() {
        this.$mdToast.hide();
        this.$timeout(()=>{
            this.loginService.handleLoginClick();
        }, 200);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/timeoutToast/timeoutToast.directive.ts